export const getInitials = fullTitle => {
    if (!fullTitle) {
        return ''
    }
    let string = ''
    let allInitialsLetters = ''
    let onlyUpperCaseLetters = ''

    for (let i = 0; i < fullTitle.length; i++) {
        if (i == 0) {
            allInitialsLetters += fullTitle[i]
            onlyUpperCaseLetters += fullTitle[i]
        } else if (fullTitle[i] == ' ' || fullTitle[i] == '-') {
            const charCode = fullTitle[i + 1].charCodeAt()
            if (charCode >= 65 && charCode <= 90) {
                onlyUpperCaseLetters += fullTitle[i + 1]
            }
            allInitialsLetters += fullTitle[i + 1]
        }
    }

    if (onlyUpperCaseLetters.length >= 2) {
        string = onlyUpperCaseLetters.substring(0, 3)
    } else {
        string = allInitialsLetters.substring(0, 3)
    }

    return string.toUpperCase()
}

export const removeTagsHTML = stringName => {
    if (stringName) {
        return stringName.replace(/<.*?>/g, '')
    }
    return
}
